import { render, staticRenderFns } from "./project-partners.vue?vue&type=template&id=626426a2"
import script from "./project-partners.vue?vue&type=script&lang=js"
export * from "./project-partners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports